import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { AccountModal, Spinner } from '../../components'
import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login';
import Consts from '../../config/constants'

const SignInModal = ({
    handleSubmit,
    isVisible,
    onCloseModal,
    onSubmit,
    facebookSignIn,
    openRecoveryPasswordModal,
    openSignUpModal,
    message,
    loading,
    googleSignIn
}) => (
    <AccountModal isVisible={isVisible} onCloseModal={() => onCloseModal()}>
        <p className="account-modal-title">Entrar</p>
        { message &&
            <div className={`callout ${message.type}`} >
                <p className="callout-message">{message.message}</p>
            </div>
        }
        <form onSubmit={handleSubmit(onSubmit)}>
            <div>
                <FacebookLogin
                    appId={Consts.FACEBOOK_APP_ID}
                    autoLoad={false}
                    textButton="Entrar com o Facebook"
                    size="small"
                    cssClass="facebook-button"
                    icon={<i className="icon-facebook" />}
                    disableMobileRedirect={true}
                    fields="id,first_name,last_name,email,picture,gender,link,birthday,age_range,location,locale"
                    scope="user_link,user_gender,user_location,user_birthday,user_age_range,email"
                    callback={facebookSignIn}
                />
                 <GoogleLogin
                    clientId={Consts.GOOGLE_APP_URL}
                    buttonText="Entrar com o Google"
                    className="google-login"
                    onSuccess={googleSignIn}
                    cookiePolicy={'single_host_origin'}
                />
            </div>
            <div className="account-signin-modal-divider"></div>
            <Field component="input" className="account-modal-input" required name="email" placeholder="E-mail" type="email" />
            <Field component="input" className="account-modal-input" required name="password" placeholder="Senha" type="password" />
            <label className="account-modal-checkbox" htmlFor="remember">
                <Field component="input" name="remember" value="1" type="checkbox" />
                Mantenha-me conectado
            </label>
            <button className="account-button" type="submit">Entrar</button>
            <span className="signin-forgot-password"> Esqueceu sua senha?
                <a onClick={openRecoveryPasswordModal} title="Esqueci a senha"> Clique aqui.</a>
            </span>
        </form>
        <div className="account-modal-footer">
            <p className="account-modal-footer-info">
                Não possui uma conta? <a onClick={openSignUpModal} title="Criar conta do Beduka">Crie agora</a>
            </p>
        </div>
        <Spinner isLoading={ loading } />
    </AccountModal>
);

export default reduxForm({ form: 'signInForm' })(SignInModal);
